// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_RecalcularSnapshotResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for recalcular_snapshot endpoint
 *
 * Returns recalculated snapshot totals for a fechamento.
 *
 * `totals` reuses Fechamentos_PlanoContaTotaisRow — same shape, same source
 * (Plano_contas_snapshots_model::getTotals).
 */
import type { Fechamentos_PlanoContaTotaisRow } from './Fechamentos_PlanoContaTotaisRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planoscontas_RecalcularSnapshotResponseDados {
fechamento_id: number
valor_realizado: number
totals: Fechamentos_PlanoContaTotaisRow
}

export type Planoscontas_RecalcularSnapshotResponse = ApiResponse<Planoscontas_RecalcularSnapshotResponseDados>;

registerResponseContract('Planoscontas_RecalcularSnapshotResponse', {
  fechamento_id:   { type: 'number',  required: true },
  valor_realizado: { type: 'number',  required: true },
  totals: {
    type: 'object',
    required: true,
    fields: {
      total_previsto:      { type: 'number',  required: true },
      total_efetivo:       { type: 'number',  required: true },
      variacao_percentual: { type: 'number',  required: false },
      num_contas:          { type: 'number',  required: true },
    },
  },
})
